/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  UniswapV3SwapV2,
  UniswapV3SwapV2Interface,
} from "../UniswapV3SwapV2";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_router",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "PoolNotSet",
    type: "error",
  },
  {
    inputs: [],
    name: "RouterIsZero",
    type: "error",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IUniswapV3Pool",
            name: "pool",
            type: "address",
          },
          {
            internalType: "bool",
            name: "token0IsInterim",
            type: "bool",
          },
        ],
        internalType: "struct PricePath[]",
        name: "_pricePath",
        type: "tuple[]",
      },
    ],
    name: "createPath",
    outputs: [
      {
        internalType: "bytes",
        name: "path",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_priceProvider",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "fetchPricePath",
    outputs: [
      {
        components: [
          {
            internalType: "contract IUniswapV3Pool",
            name: "pool",
            type: "address",
          },
          {
            internalType: "bool",
            name: "token0IsInterim",
            type: "bool",
          },
        ],
        internalType: "struct PricePath[]",
        name: "pricePath",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "router",
    outputs: [
      {
        internalType: "contract ISwapRouter",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "spenderToApprove",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_priceProvider",
        type: "address",
      },
      {
        internalType: "address",
        name: "_siloAsset",
        type: "address",
      },
    ],
    name: "swapAmountIn",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amountOut",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_priceProvider",
        type: "address",
      },
      {
        internalType: "address",
        name: "_siloAsset",
        type: "address",
      },
    ],
    name: "swapAmountOut",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type UniswapV3SwapV2ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: UniswapV3SwapV2ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class UniswapV3SwapV2__factory extends ContractFactory {
  constructor(...args: UniswapV3SwapV2ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "UniswapV3SwapV2";
  }

  deploy(
    _router: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<UniswapV3SwapV2> {
    return super.deploy(_router, overrides || {}) as Promise<UniswapV3SwapV2>;
  }
  getDeployTransaction(
    _router: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_router, overrides || {});
  }
  attach(address: string): UniswapV3SwapV2 {
    return super.attach(address) as UniswapV3SwapV2;
  }
  connect(signer: Signer): UniswapV3SwapV2__factory {
    return super.connect(signer) as UniswapV3SwapV2__factory;
  }
  static readonly contractName: "UniswapV3SwapV2";
  public readonly contractName: "UniswapV3SwapV2";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): UniswapV3SwapV2Interface {
    return new utils.Interface(_abi) as UniswapV3SwapV2Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): UniswapV3SwapV2 {
    return new Contract(address, _abi, signerOrProvider) as UniswapV3SwapV2;
  }
}
